<template>
  <b-container
    class="banner"
    class="whitebg">
    <div class="paragraphSpace">
      There are currently no games running and public access to wolf pack tracking has been closed. Sign up for Wolf Alerts to get advance notice of upcoming games, and other updates from the UK's (re)-wilding community.
  </div>

  <b-button
  class="alertButton"
  class="paragraphSpace"
  href="https://wolves.live/sign-up-for-wolf-alerts/"
  >
  Sign Up For Wolf Alerts
  </b-button>

  <div class="paragraphSpace">
    Check out the gallery of images of the UK's wolf packs below, submitted by players since 2018 
  </div>

  </b-container>
</template>

<script>
export default {
  name: "NoPlayBanner",
};
</script>

<style scoped>
.banner {
  margin: 0;
  display: flex;
  justify-items: center;
}

.banner .msg {
  flex-grow: 1;
  flex: 1;
}

.banner > * {
  display: flex;
  flex-direction: column;
  align-self: center;
}

.whitebg{
  background-color: white;
  padding: 0.3em;
  width: 100%;
  max-width: 1100px;
  margin-bottom: 1.2em;
  margin-top: 1.2em;
}

.paragraphSpace{
  margin-bottom: 1em;
}

</style>



// WEBPACK FOOTER //
// src/components/NoPlayBanner.vue